import { getPointeuseToken } from "@/services";
import { checkCompanyStatus } from "@/services/company.service";
import { useQueryClient } from "@tanstack/react-query";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { io, Socket } from "socket.io-client";
const WS_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

interface WebSocketContextType {
    isBlocked: boolean;
    isCheckingStatus: boolean;
}

interface WebSocketProviderProps {
    children: React.ReactNode;
  }

const WebSocketContext = createContext<WebSocketContextType | undefined>(undefined)

export const useWebSocket = () => {
    const context = useContext(WebSocketContext);

    if(!context) {
        throw new Error("useWebSocket doit être utilisé dans un WebSocketProvider");
    }

    return context;
}

export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ children }) => {

    // Etats
    const [isBlocked, setIsBlocked] = useState(true);
    const [isCheckingStatus, setIsCheckingStatus] = useState(true);
    
    // Référence pour le socket
    const socketRef = useRef<Socket | null>(null);

    // QueryClient pour invalider les queries
    const queryClient = useQueryClient();


    useEffect(() => {
      const token = getPointeuseToken();


        // Si pas de token, ne pas se connecter
    if (!token) {
        setIsCheckingStatus(false);
        return;
      }

      // Fonction pour récupérer l'état initial
    const fetchInitialStatus = async () => {
        try {
          const status = await checkCompanyStatus();
          setIsBlocked(!status.isActive);
        } catch (error) {
          console.error("❌ Erreur lors de la récupération de l'état initial:", error);
          setIsBlocked(true);
        } finally {
          setIsCheckingStatus(false);
        }
      };

      fetchInitialStatus();

      // Créer la connexion WebSocket
    const socket = io(WS_URL, {
        auth: { token },
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5,
      });
  
      socketRef.current = socket;
  
      // Écouter les événements de connexion
      socket.on("connect", () => {});

      socket.on("disconnect", () => {});
  
      socket.on("connect_error", (error) => {
        console.error("❌ Erreur de connexion WebSocket:", error.message);
      });
  
      // ÉVÉNEMENTS MÉTIER
      socket.on("company_blocked", () => {
        console.log("Entreprise bloquée " );
        setIsBlocked(true);
      });

      socket.on("company_unblocked", () => {
        console.log("Entreprise débloquée");
        setIsBlocked(false);
      });

      socket.on("refresh_employees", () => {
        queryClient.invalidateQueries({ queryKey: ["employees"] });
      });

      socket.on("refresh_shifts", () => {
        queryClient.invalidateQueries({ queryKey: ["shifts"] });
      });

      // Cleanup
      return () => {
        socket.disconnect();
        socketRef.current = null;
      };
    }, [queryClient]);
  
    // Valeur du contexte
    const value = {
      isBlocked,
      isCheckingStatus,
    };

    // if (isCheckingStatus) {
    //   return null;
    // }
    
    // if (!isConfigured()) {
    //   return <LoginConfig />;
    // }
    
    // if (isBlocked) {
    //   return <BlockedScreen />;
    // }
    
    return (
      <WebSocketContext.Provider value={value}>
        {children}
      </WebSocketContext.Provider>
    );
}